export default {
  default: {
    signAs: 'Sign as {name}',
    signed: 'Signed',
    waiting: 'Waiting',
  },
}
